import React from 'react';
import Flex from './Flex';
import Button from './Button';
import { useTranslation } from 'react-i18next';

type Props = {
    checked?: boolean;
    onCheckedChange?: (checked: boolean) => void;
    onCancel: () => void;
    onConfirm: () => void;
    cancelLabel?: string;
    confirmLabel?: string;
    confirmDisabled?: boolean;
    checkboxId?: string;
    checkboxName?: string;
};

const DialogWithDontAskAgainActions: React.FC<Props> = ({
    checked,
    onCheckedChange,
    onCancel,
    onConfirm,
    cancelLabel,
    confirmLabel,
    confirmDisabled = false,
    checkboxId = 'dont-ask-again',
    checkboxName = 'dont-ask-again',
}) => {
    const { t } = useTranslation();
    return (
        <Flex className="py-2 pl-3 pr-3" justify="between" align="center" gap="1rem" width="100%">
            <Flex>
                {checked !== undefined && onCheckedChange !== undefined && (
                    <>
                        <input
                            type="checkbox"
                            name={checkboxName}
                            id={checkboxId}
                            checked={checked}
                            onChange={(e) => onCheckedChange && onCheckedChange(e.target.checked)}
                        />
                        <label htmlFor={checkboxId} className="ml-2">
                            {t('dontAskAgain')}
                        </label>
                    </>
                )}
            </Flex>
            <Flex gap="0.5rem">
                <Button rounded onClick={onCancel}>
                    {cancelLabel || t('cancel')}
                </Button>
                <Button rounded onClick={onConfirm} main disabled={confirmDisabled}>
                    {confirmLabel || t('confirm')}
                </Button>
            </Flex>
        </Flex>
    );
};

export default DialogWithDontAskAgainActions;
